export const DOC_DRAG_TYPE = 'application/x-fokus-doc-id';
export const FOLDER_DRAG_TYPE = 'application/x-fokus-folder-id';

/** Same 25/50/25 split as campaign tree rows. */
export const folderDropZone = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  const y = e.clientY - rect.top;
  const height = rect.height || 1;
  if (y < height * 0.25) return 'above';
  if (y > height * 0.75) return 'below';
  return 'middle';
};

/** Persist whether the Unfiled inbox is open. Default is collapsed. */
export const UNFILED_EXPANDED_KEY = 'fokus:docs-sidebar-unfiled-expanded';
